import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { VisibilityOff } from "@material-ui/icons";
import Visibility from "@material-ui/icons/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogTitle, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import jwt_decode from "jwt-decode";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import mysmartguardplus from "../../../src/assets/USA_Images/applicationLogo.svg";
import { ReactComponent as PassIcon } from "../../assets/passIcon.svg";
import { ReactComponent as USAPassIcon } from "../../assets/USA_Images/login_images/pass_icon.svg";
import { ReactComponent as USAUserIcon } from "../../assets/USA_Images/login_images/userIcon.svg";
import { ReactComponent as UserIcon } from "../../assets/UserIcon.svg";
import USACustomTextfield from "../../components/CustomInputs/USACustomTextfield";
import Toast from "../../components/ToastContainer/CustomToast";
import CommonUtil from "../../components/Util/CommonUtils";
import { authorizeUser } from "../../slices/onboard/LoginSlice";
import "./custom.css";
import LoginLayoutV2 from "./LoginLayoutV2";

const privacyPolicy =
  "https://myspprivacy.s3.us-east-1.amazonaws.com/MSG%2BPrivacy+Policy.pdf";
const userAggreement =
  "https://myspprivacy.s3.us-east-1.amazonaws.com/MSG%2BUser+Agreement.pdf";

const useStyles = makeStyles((theme) => ({
  form: {
    // width: "70%",
    marginTop: theme.spacing(3),
    backgroundColor: "rgb(15 90 156 / 17%)",
    backdropFilter: "blur(5px)",
  },
  input: {
    "&:-webkit-autofill": {
      WebkitTextFillColor: "#fff !important",
    },
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle variant="h4" {...other}>
      {children}
      {onClose ? (
        <IconButton
          style={{ float: "right" }}
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 0,
            top: 3,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function LoginFormV2(props) {
  const { t } = useTranslation();
  const [hovered, setHovered] = useState(false);
  const dispatch = useDispatch();
  const classes = useStyles();
  const [userAgreement, setUserAgreement] = React.useState(false);
  const [version, setVersion] = useState(process.env.REACT_APP_VERSION);
  const [init, setInit] = useState({
    userAgreement: true,
    termsCondition: true,
  });
  const history = useHistory();
  const [captchaText, setCaptchaText] = useState("");
  const [userInput, setUserInput] = useState("");
  const [showCaptcha, setShowCaptcha] = useState(
    localStorage.getItem("showCaptcha") === "true",
  );
  const canvasRef = useRef(null);
  const [captchaValue, setCaptchaValue] = useState("");

  const [values, setValues] = useState({
    email: "",
    password: "",
    showPassword: false,
  });

  const [error, setError] = useState({
    email: false,
    password: false,
  });
  const store = useSelector((state) => state);

  const query = new URLSearchParams(props.location.search);

  useEffect(() => {
    return () => {
      if (history.action === "POP") {
        history.replace("/vis/login");
      }
    };
  }, [history]);

  useEffect(() => {
    if (showCaptcha) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      initializeCaptcha(ctx);
    }
  }, [showCaptcha]);

  const handleChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;

    setValues({
      ...values,
      [name]: value,
    });
    setError({
      [name]: false,
    });
  };

  const handleClickShowPassword = (event) => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const passwordToHexa = (password) => {
    let hashPassword = "";
    for (let i = 0; i <= password.length; i++) {
      const passowrdHexaValue = password.charCodeAt(i).toString(16);
      // Pad with zero's to ensure two-digit representation
      hashPassword += passowrdHexaValue.padStart(2, "0");
    }
    return hashPassword;
  };

  const resetCaptcha = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    initializeCaptcha(ctx);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (CommonUtil.isEmptyString(values.email)) {
      setError({ ...error, email: true });
      Toast(t("COMMON053"), "error");
      return;
    }

    if (CommonUtil.isEmptyString(values.password)) {
      setError({ ...error, password: true });
      Toast(t("REGISTERUSER0002"), "error");
      return;
    }

    if (showCaptcha && !userInput) {
      Toast(t("Please enter the CAPTCHA."), "error");
      return;
    }

    if (showCaptcha && userInput !== captchaText) {
      Toast(t("Entered CAPTCHA is incorrect."), "error");
      return;
    }

    const user = {
      userName: values.email.trim(),
      password: passwordToHexa(values.password.trim()).replace("NaN", ""),
    };

    dispatch(authorizeUser(user))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          localStorage.removeItem("showCaptcha");
          localStorage.setItem(
            process.env.REACT_APP_TEMP_TOKEN,
            "Bearer " + data.data.access_token,
          );
          const decoded = jwt_decode(data.data.access_token);
          localStorage.setItem("applicationId", decoded.client_id);
          history.push("/vis/verify-company");
        } else {
          localStorage.setItem("showCaptcha", "true");
          setShowCaptcha(true);
          resetCaptcha();
          onFail(data);
        }
      })
      .catch((er) => {});
  };

  const onFail = (data) => {
    switch (data.code) {
      case "CVAE0112":
        Toast(t("INVALID_USERNAME_PASSWORD"), "error");
        break;
      default:
        Toast(t(data.message), "error");
        break;
    }
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
  };

  const handleOnPasteEvent = (event) => {
    event.preventDefault();
  };

  const handleOnCopyEvent = (event) => {
    event.preventDefault();
  };

  const handleOnCutEvent = (event) => {
    event.preventDefault();
  };

  const generateRandomChar = (min, max) =>
    String.fromCharCode(Math.floor(Math.random() * (max - min + 1) + min));

  const generateCaptchaText = () => {
    let captcha = "";
    for (let i = 0; i < 3; i++) {
      captcha += generateRandomChar(65, 90);
      captcha += generateRandomChar(97, 122);
      captcha += generateRandomChar(48, 57);
    }
    return captcha
      .split("")
      .sort(() => Math.random() - 0.5)
      .join("")
      .substring(0, 4);
  };

  const drawCaptchaOnCanvas = (ctx, captcha) => {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    const textColors = ["rgb(0,0,0)", "rgb(130,130,130)"];
    const letterSpace = 25;
    const xInitialSpace = 25;
    for (let i = 0; i < captcha.length; i++) {
      ctx.font = "20px Roboto Mono";
      ctx.fillStyle = textColors[Math.floor(Math.random() * 2)];
      ctx.fillText(
        captcha[i],
        xInitialSpace + i * letterSpace,
        Math.floor(Math.random() * 16 + 25),
        100,
      );
    }
  };

  const initializeCaptcha = (ctx) => {
    setUserInput("");
    const newCaptcha = generateCaptchaText();
    setCaptchaText(newCaptcha);
    setCaptchaValue(newCaptcha);
    drawCaptchaOnCanvas(ctx, newCaptcha);
  };

  const handleUserInputChange = (e) => {
    setUserInput(e.target.value);
  };

  return !CommonUtil.isEmptyString(query.get("code")) ? (
    <></>
  ) : (
    <>
      <LoginLayoutV2 lang={true}>
        <Box
          style={{
            width: "55%",
            backgroundColor: "rgb(15 90 156 / 17%)",
            backdropFilter: "blur(5px)",
            padding: "40px ",
            paddingBottom: "20px",
            borderRadius: "8px",
            overflowY: "auto",
            scrollbarWidth: "none",
          }}
        >
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <img
                src={mysmartguardplus}
                alt="logo"
                style={{
                  opacity: 1,
                  height: "57px",
                  width: "261px",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="h2"
                align="left"
                style={{
                  color: "rgba(255, 255, 255, 1)",
                }}
              >
                {t("LOGINFORM0002")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12}>
                  <Grid className="company_icon">
                    {process.env.REACT_APP_ENVIRONMENT === "USA" ? (
                      <USAUserIcon />
                    ) : (
                      <UserIcon className="visibleIcons" />
                    )}
                  </Grid>
                  <USACustomTextfield
                    type={"text"}
                    error={error.email}
                    name="email"
                    required={true}
                    label={t("LOGINPAGE002")}
                    value={values.email}
                    handleChange={(e) => handleChange(e)}
                    helperText={error.email}
                    validation="email"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ className: classes.input }}
                    onContextMenu={(e) => handleContextMenu(e)}
                    onPaste={(e) => handleOnPasteEvent(e)}
                    onCopy={(e) => handleOnCopyEvent(e)}
                    onCut={(e) => handleOnCutEvent(e)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Grid
                    className="company_icon"
                    style={{
                      marginLeft: "5px",
                    }}
                  >
                    {process.env.REACT_APP_ENVIRONMENT === "USA" ? (
                      <USAPassIcon />
                    ) : (
                      <PassIcon className="visibleIcons" />
                    )}
                  </Grid>
                  <USACustomTextfield
                    type={values.showPassword ? "text" : "password"}
                    error={error.password}
                    name="password"
                    required={true}
                    label={t("COMMON047")}
                    value={values.password}
                    handleChange={(e) => handleChange(e)}
                    helperText={error.password}
                    validation="password"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ className: classes.input }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="PasswordIcon"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {values.showPassword ? (
                              <Visibility className="visibleIconsDark" />
                            ) : (
                              <VisibilityOff
                                className="visibleOffIcon"
                                style={{ transform: "scaleX(-1)" }}
                              />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                      maxLength: 25,
                    }}
                    onContextMenu={(e) => handleContextMenu(e)}
                    onPaste={(e) => handleOnPasteEvent(e)}
                    onCopy={(e) => handleOnCopyEvent(e)}
                    onCut={(e) => handleOnCutEvent(e)}
                  />
                </Grid>
                {showCaptcha && (
                  <Grid item xs={12}>
                    <Box mt={1}>
                      <TextField
                        fullWidth
                        type="text"
                        placeholder={t("Captcha")}
                        value={userInput}
                        onChange={handleUserInputChange}
                        autoComplete="off"
                        label={t("Captcha")}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                          sx: {
                            color: "#FFFFFF !important",
                            fontSize: "14px",
                          },
                        }}
                        InputProps={{
                          sx: {
                            height: "50px",
                            fontSize: "14px",
                            color: "#FFFFFF", // typed text white
                            borderRadius: "10px",
                            paddingRight: "0px",

                            "& input": {
                              color: "#FFFFFF",
                              paddingLeft: "12px",
                            },

                            "& input::placeholder": {
                              color: "rgba(255,255,255,0.6)",
                              opacity: 1,
                            },

                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "rgba(255,255,255,0.4)",
                              borderWidth: "1.5px",
                            },

                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#FFFFFF", // hover white
                            },

                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#2196F3", // focus blue
                              borderWidth: "2px",
                            },
                          },

                          endAdornment: (
                            <InputAdornment
                              position="end"
                              sx={{
                                marginRight: 0,
                                height: "100%",
                              }}
                            >
                              <Box
                                sx={{
                                  height: "50px",
                                  width: "140px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderLeft: "1px solid rgba(255,255,255,0.2)",
                                  background: "#E4EDFD",
                                  borderTopRightRadius: "10px",
                                  borderBottomRightRadius: "10px",
                                  overflow: "hidden",
                                  cursor: "pointer",
                                }}
                              >
                                <canvas
                                  ref={canvasRef}
                                  width="140"
                                  height="50"
                                  onClick={() =>
                                    initializeCaptcha(
                                      canvasRef.current.getContext("2d"),
                                    )
                                  }
                                />
                              </Box>
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          "& .MuiInputLabel-root": {
                            color: "rgba(255,255,255,0.7)",
                          },

                          "& .MuiInputLabel-root.Mui-focused": {
                            color: "#2196F3",
                          },
                        }}
                      />
                    </Box>
                  </Grid>
                )}
                <Grid
                  item
                  xs={12}
                  style={{
                    paddingTop: "4px",
                  }}
                >
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Link
                      style={{
                        color: "#FFFFFF",
                        opacity: hovered ? 1 : 0.5,
                      }}
                      href="/vis/forgot-password"
                      className="forgot_password"
                      onMouseEnter={() => setHovered(true)}
                      onMouseLeave={() => setHovered(false)}
                    >
                      {t("COMMON054")}
                    </Link>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
                paddingBottom: "16px",
              }}
            >
              <Box>
                <Link
                  style={{
                    color: "#F2824C",
                    textDecoration: "none",
                    cursor: "pointer",
                    fontSize: "12px",
                  }}
                  href={userAggreement}
                  target="_blank"
                  rel="noopener noreferrer"
                  // onClick={() => window.open(userAggreement, "_blank")}
                >
                  {" "}
                  {t("User Agreement ")}
                </Link>

                <span style={{ color: "#EBF6FF", fontSize: "12px" }}>
                  {" "}
                  and{" "}
                </span>
                <Link
                  style={{
                    color: "#F2824C",
                    textDecoration: "none",
                    cursor: "pointer",
                    fontSize: "12px",
                  }}
                  href={privacyPolicy}
                  target="_blank"
                  rel="noopener noreferrer"
                  // onClick={() => window.open(privacyPolicy, "_blank")}
                >
                  {t(" Privacy Policy")}
                </Link>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                paddingBottom: "10px",
              }}
            >
              <Button
                onClick={handleSubmit}
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  backgroundColor: "#F2824C",
                  borderRadius: "40px !important",
                }}
              >
                {t("LOGINFORM0002")}
              </Button>
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                color: "rgba(255, 255, 255, 0.8)",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {version}
            </Grid>
          </Grid>
        </Box>
      </LoginLayoutV2>
    </>
  );
}
export default withRouter(LoginFormV2);
